export enum AmlStatusEnum {
    PENDING = 'PENDING',
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED',
    NEEDS_INVESTIGATION = 'NEEDS_INVESTIGATION'
}

type AmlStatusMap = Record<
    AmlStatusEnum,
    {
        asciiCode: number;
        charCode: string;
        displayValue: string;
    }
>;

export const AmlStatusMap: AmlStatusMap = {
    [AmlStatusEnum.PENDING]: {
        asciiCode: AmlStatusEnum.PENDING.charCodeAt(0),
        charCode: AmlStatusEnum.PENDING,
        displayValue: 'Pending'
    },
    [AmlStatusEnum.ACCEPTED]: {
        asciiCode: AmlStatusEnum.ACCEPTED.charCodeAt(0),
        charCode: AmlStatusEnum.ACCEPTED,
        displayValue: 'Accepted'
    },
    [AmlStatusEnum.REJECTED]: {
        asciiCode: AmlStatusEnum.REJECTED.charCodeAt(0),
        charCode: AmlStatusEnum.REJECTED,
        displayValue: 'Rejected'
    },
    [AmlStatusEnum.NEEDS_INVESTIGATION]: {
        asciiCode: AmlStatusEnum.NEEDS_INVESTIGATION.charCodeAt(0),
        charCode: AmlStatusEnum.NEEDS_INVESTIGATION,
        displayValue: 'Needs Investigation'
    }
};